// extracted by mini-css-extract-plugin
export var alertIcon = "_od-0";